import { create } from "zustand";

/** The chat that slides up over the current page («Написать в чат»). Messages stay in Query. */
interface ChatPopupState {
  conversationId: string | null;
  open: (conversationId: string) => void;
  close: () => void;
}

export const useChatPopup = create<ChatPopupState>()((set) => ({
  conversationId: null,
  open: (conversationId) => set({ conversationId }),
  close: () => set({ conversationId: null }),
}));
